import React, { useMemo } from 'react';

import IconTooltip from '../../../common/IconTooltip';

import checkIcon from '../../../../assets/changeCoverage/check-white.svg';
import infoIcon from '../../../../assets/changeCoverage/info.svg';

import styles from '../css/LimitSelector.module.css';
import { currencyFormat } from '../../../../services/utils';

const LimitSelector = ({
  onChange = () => { },
  ignoreDisabled = false,
  options = [{ display: '', id: 0, value: 0 }],
  selectedId = 0,
  title = '',
  tooltip = '',
}) => {
  const optionSorted = useMemo(() => options
    .sort((option1, option2) => option1.value - option2.value), [options]);

  const selectedValue = options?.find(({ id }) => id === selectedId);

  return (
    <div className={styles.limitSelector}>
      <span className={styles.limitSelectorTitle}>
        {title}

        {tooltip && (
          <IconTooltip
            description={tooltip}
            icon={infoIcon}
            iconClassName={styles.limitSelectorTooltipIcon}
          />
        )}
      </span>

      <div className={styles.limitSelectorOptions}>
        {optionSorted.map((option) => {
          const isSelected = option.id === selectedId;

          return (
            <button
              key={option.id}
              className={styles.limitPill}
              data-selected={isSelected}
              disabled={!ignoreDisabled && option.value > selectedValue.value}
              onClick={() => onChange(option)}
              type="button"
            >
              {isSelected && (
                <img
                  alt=""
                  className={styles.limitPillCheck}
                  src={checkIcon}
                />
              )}

              {currencyFormat({
                fixed: 0,
                value: option.display,
              })}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export { LimitSelector };
